import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 48px 0;
`
